const passwordVisibility = (buttonId = 'passwordToggle') => {
    const button = document.getElementById(buttonId);
    if (!button) {
        return;
    }

    button.addEventListener('click', () => {
        const input = button.parentNode.querySelector('input');
        if (button.classList.contains('fa-eye')) {
            button.classList.replace('fa-eye', 'fa-eye-slash');
            input.type = 'text';
        } else {
            button.classList.replace('fa-eye-slash', 'fa-eye');
            input.type = 'password';
        }
    });
};

export default passwordVisibility;
